import { useContext } from "react";
import { ColorSchemeName } from "react-native";
import { SettingsContext } from "../context/SettingsContext";

export default function useColorScheme(): NonNullable<ColorSchemeName> {
  return useContext(
    SettingsContext
  ).getColorScheme() as NonNullable<ColorSchemeName>;
}
